import React, { Component } from 'react';
import PlaceImage           from './PlaceImage';
import PlaceInfo            from './Place/containers/PlaceInfoContainer';
import PlaceNearBy          from './PlaceNearBy';
import LoadingSvg           from './LoadingSvg';

class Place extends Component {
    render = () => {
        let body;
        if (null !== this.props.place) {
            body = (
                <div>
                    <PlaceImage theme={ this.props.theme } place={ this.props.place } />
                    <PlaceInfo />
                    <PlaceNearBy nearby={ this.props.place.nearby } theme={ this.props.theme } />
                </div>
            );

        }
        else
        {
            body = (<div style={ { height: '400px' } }><LoadingSvg /></div>);
        }

        return (<div className="place-container">{ body }</div>);
    }
}

export default Place;


// WEBPACK FOOTER //
// ./src/components/Place.js